<template>
    <div class="content-wrap">
        <div class="version-list">
            <div class="version-item" v-for="i in [6, 5, 4, 3, 2, 1]">
                <div class="version-item-left flc">
                    <div class="version-item-left-img">
                        <div class="version-item-left-img-bg"></div>
                        <img src="@/assets/images/member/v2/plan/version_ico.png" alt="">
                    </div>

                    <div>
                        <div class="version-item-left-text1">版本：{{ i }}.0</div>
                        <div class="version-item-left-text2">提交时间：2022-02-24 12:22:22</div>
                    </div>
                </div>
                <img class="next-icon" src="@/assets/images/member/v2/plan/right_ico.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
/**
 * v2：历史版本
 * author：gw
 */

export default {
    name: "version"
}
</script>

<style lang="scss" scoped>
.flc {
    display: flex;
    align-items: center;
}

.content-wrap {
    min-height: 100vh;
    background: #F9F9F9;

    .version-list {
        padding: 0 32px;
        margin: 16px 0 32px;

        .version-item {
            width: 100%;
            height: 176px;
            margin-top: 32px;
            background: #FFFFFF;
            border-radius: 24px;
            padding: 0 48px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .version-item-left {


                .version-item-left-img {
                    position: relative;

                    img {
                        width: 48px;
                        height: 48px;
                        display: block;
                        margin-right: 48px;
                    }

                    .version-item-left-img-bg {
                        width: 48px;
                        height: 48px;
                        background: #7AA894;
                        border-radius: 50%;
                        opacity: 0.2;
                        position: absolute;
                        left: 0;
                        top: 0;
                    }
                }


                .version-item-left-text1 {
                    font-size: 32px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 48px;
                }

                .version-item-left-text2 {
                    font-size: 24px;
                    color: #686868;
                    line-height: 36px;
                }
            }

            .next-icon {
                width: 24px;
                height: 24px;
                display: block;
            }
        }
    }
}
</style>